import { Select } from "antd";
import * as React from "react";
import { ZAttrType, zTypeDef } from "src/business/attribute";
import { ZOption } from "src/types";
import { ZodLiteral } from "zod";

import { AttrFeatures } from "../../AttrFeatures";

type PropsSelectTopType = {
  value?: string;
  onChange?(value?: string): void;
  attrFeatures: AttrFeatures;
};

// http://jira.d4r.int/browse/MDM2-546
// Ограничение списка типов, в зависимости от фич
// Если есть ограничения на типы, то они указаны в attrFeatures.availableTypes

export const SelectTopType: React.FC<PropsSelectTopType> = (props) => {
  const { attrFeatures, value, onChange } = props;
  let options: ZOption[] = zTypeDef.def.options
    .map((it) => {
      const lit = it.def.shape.name as ZodLiteral;
      const name = lit.def.values[0];
      if (typeof name !== "string") return null;
      let label = name;
      const d = lit.description;
      if (d) label += ` (${d})`;
      return { value: name, label };
    })
    .filter((op) => !!op);

  const { availableTypes } = attrFeatures;
  if (availableTypes) {
    options = options.filter((op) => availableTypes.has(op.value as ZAttrType));
  }
  return (
    <Select value={value} onChange={onChange} options={options} allowClear />
  );
};
